import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const WeddingFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 8 0.5 L 87.999997 0.5 C 92.142081 0.5 95.499997 3.857799 95.499997 8.000001 L 95.499997 120.000011 C 95.499997 124.142213 92.142081 127.500012 87.999997 127.500012 L 8 127.500012 C 3.857917 127.500012 0.5 124.142213 0.5 120.000011 L 0.5 8.000001 C 0.5 3.857799 3.857917 0.5 8 0.5 Z M 8 0.5 "
          transform="matrix(9.375,0,0,9.367187,0,0)"
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 447.382812 313.203125 C 423.410156 330.492188 394.925781 335.453125 371.492188 323.550781 C 366.503906 321.019531 361.996094 317.84375 357.988281 314.140625 C 358.796875 314.621094 359.625 315.078125 360.472656 315.507812 C 380.421875 325.640625 406 318.601562 427.867188 299.671875 C 409.195312 283.164062 398.914062 261.117188 401.925781 238.484375 C 403.714844 225.082031 409.9375 213.109375 419.359375 203.292969 C 413.863281 209.933594 410.296875 217.546875 409.1875 225.878906 C 406.34375 247.273438 420.328125 268.355469 443.878906 282.765625 C 449.210938 275.957031 454.074219 268.347656 458.277344 260.050781 C 467.234375 242.378906 471.898438 224.132812 472.53125 207.46875 C 472.53125 207.46875 472.527344 207.46875 472.523438 207.46875 C 472.835938 198.089844 471.949219 189.28125 469.835938 181.347656 C 469.839844 181.347656 469.84375 181.347656 469.84375 181.347656 C 465.839844 166.398438 457.535156 154.539062 445.210938 148.28125 C 437.710938 144.46875 429.414062 143.085938 420.820312 143.851562 C 434.257812 141.660156 447.660156 143.320312 459.722656 149.441406 C 472.371094 155.871094 481.929688 166.386719 488.082031 179.355469 C 495.125 179.121094 502.425781 179.476562 509.859375 180.476562 C 558.097656 186.96875 593.804688 218.1875 589.554688 250.148438 C 588.8125 255.710938 586.910156 260.933594 584.015625 265.726562 C 579.457031 238.199219 546.804688 213.515625 504.527344 207.828125 C 501.542969 207.425781 498.574219 207.128906 495.640625 206.933594 C 497.792969 227.03125 493.828125 249.515625 483.0625 270.757812 C 478.746094 279.28125 473.625 287.03125 467.910156 293.914062 C 476.054688 296.679688 484.789062 298.75 493.949219 299.980469 C 545.257812 306.886719 590.582031 284.890625 595.109375 250.898438 C 595.234375 249.957031 595.324219 249.015625 595.390625 248.078125 C 596.171875 253.480469 596.234375 258.984375 595.492188 264.53125 C 589.984375 305.894531 542.148438 333.640625 488.730469 326.457031 C 473.542969 324.410156 459.53125 319.761719 447.382812 313.203125 Z M 378.988281 314.78125 C 373.394531 314.445312 368.007812 313.050781 363.003906 310.507812 C 334.238281 295.894531 328.730469 248.808594 350.71875 205.421875 C 372.707031 162.03125 413.914062 138.667969 442.675781 153.28125 C 446.234375 155.085938 449.433594 157.386719 452.269531 160.117188 C 425.726562 158.519531 394.453125 180.691406 376.296875 216.53125 C 357.027344 254.554688 358.871094 295.425781 378.988281 314.78125 Z M 465.558594 182.253906 C 467.890625 189.984375 468.96875 198.6875 468.75 207.976562 C 444.292969 211.671875 424.371094 222.777344 414.949219 238.398438 C 414.304688 234.515625 414.222656 230.578125 414.75 226.628906 C 417.613281 205.097656 437.890625 188.6875 465.558594 182.253906 Z M 465.558594 182.253906 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 187.5 355.953125 L 712.5 355.953125 C 722.855469 355.953125 731.25 364.339844 731.25 374.6875 L 731.25 899.25 C 731.25 909.597656 722.855469 917.984375 712.5 917.984375 L 187.5 917.984375 C 177.144531 917.984375 168.75 909.597656 168.75 899.25 L 168.75 374.6875 C 168.75 364.339844 177.144531 355.953125 187.5 355.953125 Z M 187.5 355.953125 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="450"
          y="1050.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
